import React, { createContext, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [pendingPath, setPendingPath] = useState(null);


  const customNavigate = (to, options = {}) => {
    setIsTransitioning(true);
    setTimeout(() => {
      navigate(to, options);
      setIsTransitioning(false);
    }, 250);
  };
  
  
  const finishNavigation = () => {
    if (pendingPath) {
      navigate(pendingPath);
      setPendingPath(null);
    }
    setIsTransitioning(false);
  };

  return (
    <NavigationContext.Provider value={{ customNavigate, finishNavigation, isTransitioning }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useCustomNavigation = () => useContext(NavigationContext);
